'use strict';

/**
 * Provided a value and a ValueType, returns the value as that value type.
 */
const getValueAsType = (value, type) => {
    return type && typeof value === "number"
        ? type.transform(value)
        : value;
};

exports.getValueAsType = getValueAsType;
//# sourceMappingURL=get-as-type.cjs.map
